const CAPI_URL        = 'https://qlhqgfpbrloaygqwyfcu.supabase.co/functions/v1/meta-capi';
const CAPI_ANON       = 'sb_publishable_Bb9aLd7CVEX7OwYcO7k2sA_Q47be6vq';
const TEST_EVENT_CODE = 'TEST44177';

// Module-level user context — set once after login, used by all CAPI calls
let _ctx = {};

export function identifyUser({ email, userId, firstName, lastName, phone } = {}) {
  _ctx = { email, userId, firstName, lastName, phone };
}

function uuid() {
  return crypto.randomUUID
    ? crypto.randomUUID()
    : Math.random().toString(36).slice(2) + Date.now().toString(36);
}

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : undefined;
}

function fbq(...args) {
  if (typeof window !== 'undefined' && window.fbq) window.fbq(...args);
}

// emailOverride — used during signup before _ctx is populated
async function sendCapi(eventName, customData = {}, eventId, emailOverride) {
  try {
    await fetch(CAPI_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${CAPI_ANON}`,
      },
      body: JSON.stringify({
        event_name: eventName,
        event_time: Math.floor(Date.now() / 1000),
        event_id: eventId,
        event_source_url: window.location.href,
        email:       emailOverride || _ctx.email       || null,
        external_id: _ctx.userId                       || null,
        first_name:  _ctx.firstName                    || null,
        last_name:   _ctx.lastName                     || null,
        phone:       _ctx.phone                        || null,
        user_agent:  navigator.userAgent,
        fbc:         getCookie('_fbc'),
        fbp:         getCookie('_fbp'),
        custom_data: customData,
        ...(TEST_EVENT_CODE ? { test_event_code: TEST_EVENT_CODE } : {}),
      }),
    });
  } catch {
    // CAPI is best-effort; pixel is the source of truth
  }
}

export function trackPageView() {
  const eventId = uuid();
  fbq('track', 'PageView', {}, { eventID: eventId });
  sendCapi('PageView', {}, eventId);
}

export function trackViewContent(adId, brand, niche) {
  const eventId = uuid();
  fbq('track', 'ViewContent', {
    content_ids: [String(adId)],
    content_name: brand,
    content_category: niche,
    content_type: 'product',
  }, { eventID: eventId });
  sendCapi('ViewContent', {
    content_ids: [String(adId)],
    content_name: brand,
    content_category: niche,
  }, eventId);
}

export function trackSearch(query) {
  const eventId = uuid();
  fbq('track', 'Search', { search_string: query }, { eventID: eventId });
  sendCapi('Search', { search_string: query }, eventId);
}

export function trackAddToWishlist(adId) {
  const eventId = uuid();
  fbq('track', 'AddToWishlist', {
    content_ids: [String(adId)],
    content_type: 'product',
  }, { eventID: eventId });
  sendCapi('AddToWishlist', { content_ids: [String(adId)] }, eventId);
}

export function trackInitiateCheckout() {
  const eventId = uuid();
  fbq('track', 'InitiateCheckout', {
    value: 499,
    currency: 'INR',
    content_name: 'Pro Upgrade',
  }, { eventID: eventId });
  sendCapi('InitiateCheckout', { value: 499, currency: 'INR', content_name: 'Pro Upgrade' }, eventId);
}

export function trackPurchase(amount = 499) {
  const eventId = uuid();
  fbq('track', 'Purchase', {
    value: amount,
    currency: 'INR',
    content_name: 'Pro Upgrade',
    content_type: 'product',
  }, { eventID: eventId });
  sendCapi('Purchase', { value: amount, currency: 'INR', content_name: 'Pro Upgrade' }, eventId);
}

export function trackSubscribe(amount = 499) {
  const eventId = uuid();
  fbq('track', 'Subscribe', {
    value: amount,
    currency: 'INR',
    predicted_ltv: String(amount * 12),
  }, { eventID: eventId });
  sendCapi('Subscribe', {
    value: amount,
    currency: 'INR',
    predicted_ltv: String(amount * 12),
  }, eventId);
}

export function trackSignUp(email) {
  const eventId = uuid();
  fbq('track', 'CompleteRegistration', { currency: 'INR', value: 0 }, { eventID: eventId });
  sendCapi('CompleteRegistration', { currency: 'INR', value: 0 }, eventId, email);
}

export function trackLead(email) {
  const eventId = uuid();
  fbq('track', 'Lead', {}, { eventID: eventId });
  sendCapi('Lead', {}, eventId, email);
}
